import { createContext, useCallback, useContext, useState, ReactNode } from "react";
import Alert from "../components/ui/alert/Alert";

type ToastVariant = "success" | "error" | "warning" | "info";

interface ToastItem {
  id: number;
  variant: ToastVariant;
  title: string;
  message: string;
}

interface ToastContextValue {
  notificar: (variant: ToastVariant, title: string, message?: string) => void;
}

const ToastContext = createContext<ToastContextValue | null>(null);

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toasts, setToasts] = useState<ToastItem[]>([]);

  const remover = useCallback((id: number) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const notificar = useCallback(
    (variant: ToastVariant, title: string, message = "") => {
      const id = Date.now() + Math.random();
      setToasts((prev) => [...prev, { id, variant, title, message }]);
      setTimeout(() => remover(id), 5000);
    },
    [remover]
  );

  return (
    <ToastContext.Provider value={{ notificar }}>
      {children}
      <div className="fixed bottom-4 right-4 z-99999 flex w-full max-w-sm flex-col gap-3">
        {toasts.map((t) => (
          <div key={t.id} className="relative shadow-lg">
            <button
              onClick={() => remover(t.id)}
              className="absolute right-3 top-3 text-gray-400 hover:text-gray-700 dark:hover:text-gray-200"
              aria-label="Fechar"
            >
              ✕
            </button>
            <Alert variant={t.variant} title={t.title} message={t.message} />
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error("useToast precisa estar dentro de <ToastProvider>");
  return ctx;
}
